module.exports = __webpack_public_path__ + "img/thumbnail.0f1a30f9.jpg";